import React from 'react';
import styled from 'styled-components';

const Line = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 2px;
    width: 100%;
    background-color: ${props => props.theme.colors.lightgray};
    margin-top: 25px;
    margin-bottom: 25px;
`;
const Text = styled.div`
    background-color: #fff;
    padding: 5px;
    font-size: 14px;
    font-weight: bold;
    margin-bottom: 4px;
`;
const Divider = ({ text = null }) => (<Line>
    <Text>
        {text}
    </Text>
</Line>);

export default Divider;



// WEBPACK FOOTER //
// ./src/components/atoms/Divider.js